import React from "react";
import ModeChoice from "./ModeChoice";

interface LightChoiceProps {
  isSelected: boolean;
}

const LightChoice: React.FC<LightChoiceProps> = ({ isSelected }) => (
  <ModeChoice
    isSelected={isSelected}
    mode="light"
    classNames={{
      container:
        "h-full w-full bg-white85 light-choice p-6 ps-4 text-end flex flex-col rounded-tr-[10px] rounded-br-[10px] ",
      title: "text-karkhana-blue font-bold text-25 uppercase ",
      description:
        "mt-3 text-black text-[13px] md:text-16 md:pb-2 flex-1 flex flex-col gap-2 md:gap-3 overflow-hidden",
    }}
    translationPrefix="lightChoice"
  />
);

export default LightChoice;
